import { RouteConfig } from 'vue-router';

/* eslint-disable @typescript-eslint/explicit-function-return-type */
const modularLandingPageRoutes: RouteConfig[] = [
	{
		path: `/campaigns/:campaignName`,
		name: 'campaign-partner-custom',
		props: true,
		component: () =>
			import(
				/* webpackChunkName: "modular-campaign-landing-page" */ '@views/marketing-site/modular-landing-page.vue'
			)
	},
	{
		path: '/starter-portfolio',
		name: 'starter-landing-page',
		props: {
			campaignName: 'starter-portfolio'
		},
		component: () =>
			import(/* webpackChunkName: "starter-landing-page" */ '@views/marketing-site/modular-landing-page.vue')
	},
	{
		path: `/acq-plus/start`,
		name: 'campaign-default',
		props: {
			campaignName: 'acq-plus-start',
			isAcqPlusStart: true
		},
		component: () =>
			import(
				/* webpackChunkName: "modular-acqplus-start-landing-page" */ '@views/marketing-site/modular-landing-page.vue'
			)
	},
	{
		path: `/affiliates/no-fees`,
		name: 'campaign-nofees',
		props: {
			campaignName: 'affiliates-no-fees',
			isAffiliateNoFees: true
		},
		component: () =>
			import(
				/* webpackChunkName: "modular-affiliates-no-fees-landing-page" */ '@views/marketing-site/modular-landing-page.vue'
			)
	},
	{
		path: `/invitation-program/welcome`,
		name: 'referral-welcome',
		props: {
			campaignName: 'invitation-program-welcome',
			isInvitationProgram: true
		},
		component: () =>
			import(
				/* webpackChunkName: "modular-invitation-program-landing" */ '@views/marketing-site/modular-landing-page.vue'
			)
	},
	{
		path: `/partner`,
		name: 'campaign-partner-default',
		props: {
			campaignName: 'partner'
		},
		component: () =>
			import(/* webpackChunkName: "campaign-partner-default" */ '@views/marketing-site/campaign/partner.vue')
	},
	{
		path: `/partner-promo`,
		name: 'campaign-partner-promo',
		props: {
			campaignName: 'partner-promo'
		},
		component: () =>
			import(/* webpackChunkName: "campaign-partner-promo" */ '@views/marketing-site/campaign/partner.vue')
	}
];

export default modularLandingPageRoutes;
